import request from "./../utils/request";

export function loginAction(payload) {
  return request.post("auth/login", {
    userName: payload.email,
    password: payload.password
  });
}

export function profile(payload) {
  return request.get("/User/Profile");
}

export async function getUserDetails() {
  return request.get("User/Details");
}
